export default {
  name: "ExportCsvDialog",
  props: ["customPoiImageTypes", "exportCsv"],
  data: () => ({
    dialog: false,
    imageTypes: ["1. Bild"],
    imageType: "1. Bild"
  }),
  mounted() {
    this.imageTypes = this.imageTypes.concat(this.customPoiImageTypes);
  },
  methods: {
    closeDialogAndExport() {
      this.exportCsv(this.imageType);
      this.dialog = false;
    }
  }
};
